import { COUNTRIES } from '@config/constants'

export const IMPACT_CHAMPION_TAG_ICONS = [
  'SellerPlatinium',
  'SellerGold',
  'SellerSilver',
  'SellerBronze',
]

export const COUNTRIES_WITH_EXTENDED_DISPLAY_PRICE = [
  COUNTRIES.FR,
  COUNTRIES.DE,
]
